export function elsevierStyleSheetJSfileImport() {
  const script = document.createElement('script');
  script.src = '/ElsevierStyleSheet/javascript.v2.1.15.js'; // Ensure this path is correct
  script.async = true;

  script.onload = () => {
      console.log('Script loaded successfully');
  };

  script.onerror = () => {
      console.error(`Error loading script: ${script.src}`);
  };

  document.body.appendChild(script);
}

export function indianCurrencyFormat(number) {
  return new Intl.NumberFormat("en-IN").format(number)
}

export function createFileDownloadUrl(file) {
  const blob = new Blob([file]);
  const fileDownloadUrl = URL.createObjectURL(blob);
  return fileDownloadUrl;
}


export function calculateDiscountAmount(actualPrice, discountPercentage) {
  return ((actualPrice * discountPercentage / 100).toFixed(2));
}

export function calculateSubTotalAmount(products) {
  return ((products.reduce(
    (sum, element) =>
      sum + element.total_price * element.quantity,
    0
  ) - products.reduce(
    (discount, element) =>
      discount + (element.discount_percentage * element.total_price * element.quantity / 100),
    0
  )).toFixed(2))
}

